export const DROPSHIP_ORDERS_OFFSET = 'DROPSHIP_ORDERS_OFFSET';
export const DROPSHIP_ORDERS_PER_PAGE = 'DROPSHIP_ORDERS_PER_PAGE';
export const DROPSHIP_ORDERS_COUNT = 'DROPSHIP_ORDERS_COUNT';
export const DROPSHIP_ORDERS_FILTERS = 'DROPSHIP_ORDERS_FILTERS';
export const DROPSHIP_ORDERS_REPORT = 'DROPSHIP_ORDERS_REPORT';
export const DROPSHIP_ORDERS_REPORT_CLOSE = 'DROPSHIP_ORDERS_REPORT_CLOSE';
export const DROPSHIP_ORDERS_SEARCH = 'DROPSHIP_ORDERS_SEARCH';
export const DROPSHIP_ORDERS_SORT = 'DROPSHIP_ORDERS_SORT';
export const DROPSHIP_ORDERS_FILTER_DATA = 'DROPSHIP_ORDERS_FILTER_DATA';
export const DROPSHIP_ORDERS_LOADING = 'DROPSHIP_ORDERS_LOADING';
export const DROPSHIP_ORDERS_STATUS_COUNT = 'DROPSHIP_ORDERS_STATUS_COUNT';
export const DROPSHIP_ORDERS_SUPPLIER = 'DROPSHIP_ORDERS_SUPPLIER';
